import { Box, type BoxProps, Typography, useTheme } from '@mui/material';
import { Warning2 } from 'iconsax-react';
import type { FC } from 'react';

import { hasValue } from '@core/utils/equality';

interface SlabServerErrorProps extends Omit<BoxProps, 'children'> {
  errorMessage?: string;
}

export const SlabServerError: FC<SlabServerErrorProps> = ({ errorMessage, sx, ...props }) => {
  const theme = useTheme();

  if (!hasValue(errorMessage) || errorMessage === '') return null;

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', ...sx }} {...props}>
      <Warning2 size={28} color={theme.palette.SlabRed[600]} />
      <Typography color={theme.palette.SlabRed[600]} variant='h6'>
        {errorMessage}
      </Typography>
    </Box>
  );
};
